import { render } from "./Interview.vue?vue&type=template&id=64dd0bc4&ts=true"
import script from "./Interview.vue?vue&type=script&lang=ts"
export * from "./Interview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__